import { DisplayValuesMap } from '~/common/types/data';
import { VisitOutcome } from '~/common/types/visits';

export const visitOutcomeDisplayValues: DisplayValuesMap<VisitOutcome> = {
  'failed:inconvenient': 'Failed, inconvenient',
  'failed:named-tenant-not-home': 'Failed, named tenant not home',
  'failed:nobody-home': 'Failed, nobody home',
  'failed:refusal-to-answer-door': 'Failed, refusal to answer door',
  'failed:refusal-to-cooperate': 'Failed, refusal to co-operate',
  'failed:other-reason': 'Failed, other reason',
  'success:data-validated': 'Success, data validated',
};
